<template lang='pug'>
.container-fluid.p-0.push-wrapper
	.container
		.row
			.col
				.row
					.col-12.my-header.font-weight-bold
						| Договоры
	.container.mt-5
		.white_block
			.row
				.col
					| Пользователь:
					select(v-model="user_id")
						option(v-for="user of users", :value="user.id") {{ user.id }} | {{ user.name }} - {{ user.email }}
					button(@click="GetLegal", :disabled="!legal.empty && !legal.loaded") Выбрать
			.row(v-if="!legal.empty && !legal.loaded")
				.col
					.spinner-border(role="status")
						span.sr-only Loading...
			.row(v-if="!legal.empty && legal.loaded")
				.col
					h4 Юридическая информация
					div(v-if="legal.legal_entity")
						| # {{ legal.legal_entity.id }}
						br
						| Наименование: {{ legal.legal_entity.name }}
						br
						| Форма предприятия: {{ legal.legal_entity.form }}
						br
						| ИНН: {{ legal.legal_entity.inn }}
						br
						| КПП: {{ legal.legal_entity.kpp }}
						br
						| Адрес: {{ legal.legal_entity.address }}
					div(v-else) Юридическая информация не заполнена пользователем.
				.col
					h4 Договор
					div(v-if="legal.contract")
						| # {{ legal.contract.id }} / {{ legal.contract.contract_number }}
						br
						| Договор в действии?
						b {{ legal.contract.signed_we && legal.contract.signed_them ? 'Да' : 'Нет' }}
						br 
						| Дата генерации (UTC): {{ legal.contract.createdAt }}
						br
						div(v-if="legal.contract.link_original")
							a(:href="legal.contract.link_original", target="_blank") 👉 Ссылка на оригинал .pdf
						div(v-else) 🛑 Договор не сгенерирован

						div(v-if="legal.contract.link_full_signed")
							a(:href="legal.contract.link_full_signed", target="_blank") 👉 Ссылка на подписанный
						div(v-else) 🛑 Подписанный договор не загружен

						| Они подписали?
						b {{ legal.contract.signed_them ? 'Да' : 'Нет' }}
						br
						| Мы подписали?
						b {{ legal.contract.signed_we ? 'Да' : 'Нет' }}
						button(
							@click="SignContract(legal.contract.id)",
							v-if="!legal.contract.signed_we",
							:disabled="sign.loading"
						) Подписать
					div(v-else) Договор ещё не был сгенерирован пользователем.
</template>
<script>
	import moment from "moment";
	import apiDriver from "../../apiDriver";

	export default {
		components: {},

		data() {
			return {
				users: [],
				bonus: true,
				amount: 0,
				comment: "",
				user_id: -1,
				loading: false,
				legal: {
					empty: true,
					loaded: false,
					bills: {},
					contract: {},
					legal_entity: {},
				},
				sign: {
					loading: false,
				},
			};
		},

		computed: {},

		mounted() {
			this.loadUsers();
		},

		methods: {
			async loadUsers() {
				let users = (await apiDriver.admin.users.list()).users;
				for (let u of users) u.created = moment(u.createdAt).format("DD.MM.YYYY");
				this.users = users;
				if (this.$route.query.user_id) {
					this.user_id = this.$route.query.user_id;
					this.GetLegal();
				}
			},
			async GetLegal() {
				this.legal.loaded = false;
				this.legal.empty = false;
				console.log("GetLegal");
				let legal = await apiDriver.admin.users.legal.get(this.user_id);
				console.log("legal: ", legal);
				if (!legal) return console.log("error while loading legal");
				this.legal.bills = legal.info.bills.bills;
				this.legal.contract = legal.info.contract.contract;
				this.legal.legal_entity = legal.info.legal_entity.legal_entity;
				this.legal.loaded = true;
			},
			async SignContract(contract_id) {
				this.sign.loading = true;
				let sign = await apiDriver.admin.users.legal.signContract(contract_id);
				console.log("sign: ", sign);
				if (!sign) return console.log("error while signing contract");
				this.sign.loading = false;
				this.GetLegal();
			},
		},
	};
</script>
<style scoped lang="stylus">
	div {
		cursor: default;
	}

	.my-header {
		font-size: 26pt;
	}

	.header-pre-push {
		font-size: 1.5rem;
	}

	.header-push {
		font-size: 1.5rem;
		color: black;
	}

	.main_amount {
		font-size: 26pt;
	}

	.user {
		&.red {
			.white_block {
				border-left: 2px solid red;
			}
		}

		.id {
			font-size: 10pt;
			color: gray;
		}

		.name {
			font-size: 16pt;
			display: inline-block;
		}

		.email {
			display: inline-block;
			margin-left: 10px;
			color: gray;
			position: relative;
			top: -2px;
		}

		.franchised_sum {
			position: absolute;
			top: 10px;
			right: 30px;
			background: #4CAF50;
			padding: 5px 10px;
			font-size: 10pt;
			border-radius: 5px;
			color: white;
		}

		.user_balances {
			border-left: 2px solid #eee;
			padding-left: 10px;
			margin: 10px 0;

			.real {
				display: inline-block;
			}

			.bonus {
				display: inline-block;
				margin-left: 10px;
				color: gray;
			}
		}
	}
</style>
